import { render, staticRenderFns } from "./editTab.vue?vue&type=template&id=26d9e374"
import script from "./editTab.vue?vue&type=script&lang=js"
export * from "./editTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports